import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

const firebaseApp = firebase.initializeApp({
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  //autu domain dev: "mnes-mnist-imagestudy.firebaseapp.com"
  //autu domain deploy: "msta-test.web.app"
  apiKey: "AIzaSyA_EzPvJ7KLb2KR19HffL3rwQM6XWYc88s",
  authDomain : "mnist-msta.web.app",
  databaseURL: "https://mnes-mnist-imagestudy-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "mnes-mnist-imagestudy",
  storageBucket: "mnes-mnist-imagestudy.appspot.com",
  messagingSenderId: "742122804599",
  appId: "1:742122804599:web:4c68fd1ea6be2aa1bdfd72",
  measurementId: "G-G0X4E1CGY0",
});

const storage = firebaseApp.storage();
export const auth = firebaseApp.auth();
export const storageRef = storage.ref();
export const db = firebaseApp.firestore();
export const provider = new firebase.auth.GoogleAuthProvider();
